import type React from 'react';
import styles from './InputError.scss';

const InputError = ({ error = '' }: { error: React.ReactNode }) => {
  return <span className={styles.error}>{error}</span>;
};

export default InputError;
